<dv-dialog-content>
  <div class="delete-fleet-location-dialog">
    <dv-dynamic-form
      [elements]="fleetLocationElements | translateElements"
      [formGroup]="formGroup">
    </dv-dynamic-form>
  </div>
  <dv-button footer-right (click)="cancel()">
    {{ 'General.Cancel' | translate }}
  </dv-button>
  <dv-button
    footer-right
    color="danger"
    (click)="performSave()"
    [disabled]="!formGroup.valid || !formGroup.dirty">
    {{ 'General.Confirm' | translate }}
  </dv-button>
</dv-dialog-content>
